import React from 'react';
import Layout from './components/Layout';
import SEO from './components/SEO';
import { Link } from 'react-router-dom';

const DispatchPage: React.FC = () => {
  return (
    <Layout>
      <SEO 
        title="Dispatch | NOPRBLM"
        description="Insights, analysis, and perspectives on creativity, technology, and culture from the NOPRBLM community."
        keywords="NOPRBLM, dispatch, articles, insights, technology, creativity, culture, brand"
        canonicalUrl="/dispatch"
      />
      
      <section className="hero-simple">
        <h1>Dispatch</h1>
        <p>Insights, analysis, and perspectives on creativity, technology, and culture from the NOPRBLM community.</p>
      </section>
      
      <section className="section dispatch-section">
        <div className="dispatch-layout">
          <div className="dispatch-main">
            <div className="coming-soon-container">
              <h2>Coming Soon</h2>
              <p>New articles and insights are on the way. Check back soon for updates from the NOPRBLM community.</p>
            </div>
          </div>
          
          <div className="dispatch-sidebar">
            <div className="sidebar-section">
              <h3>Contributors</h3>
              <div className="contributor">
                <div className="contributor-image">
                  <img src="/images/cm.jpg" alt="Clare Maguire" />
                </div>
                <div className="contributor-info">
                  <h4>Clare Maguire</h4>
                  <p>Editor in Chief</p>
                </div>
              </div>
            </div>
            
            <div className="sidebar-section">
              <h3>Categories</h3>
              <ul className="categories-list">
                <li><a href="#">Music</a></li>
                <li><a href="#">Technology</a></li>
                <li><a href="#">Blockchain Technology</a></li>
                <li><a href="#">Community</a></li>
                <li><a href="#">Experience</a></li>
                <li><a href="#">Sustainability</a></li>
                <li><a href="#">Creative</a></li>
                <li><a href="#">Culture</a></li>
              </ul>
            </div>
            
            <div className="sidebar-section">
              <h3>Subscribe to Dispatch</h3>
              <p>Stay updated with our latest insights and perspectives.</p>
              <form className="subscribe-form">
                <input type="email" placeholder="Your email" required />
                <div className="form-button-center">
                  <button type="submit">Subscribe</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default DispatchPage;